module.exports = __webpack_public_path__ + "static/media/model_dorm.13c605ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/work/assets/model_dorm.png
// module id = 382
// module chunks = 0